import { TokenResponse } from '@openid/appauth';
import { createTokenRefresher } from '@oolio-group/client-utils';
import config from '../config';
import { Session } from '../state/Session';
import * as settings from '../state/preferences';
import { sessionSubject } from '../state/sessionObservable';
import { isEmbedded, refreshFromHost } from '../embedded/embedded';

// Shared across every refresh trigger in cds-app (this file, App.tsx's
// retryAwait, tokenManager.ts, and authFlowLink.ts's GraphQL TokenRefreshLink)
// so they single-flight behind one in-flight Auth0 exchange instead of
// racing each other. Embedded mode skips Auth0 and asks the till instead.
const refreshFromAuth0 = createTokenRefresher(
  {
    clientId: config.auth0.clientId,
    redirectUrl: config.auth0.redirectUrl,
    issuer: config.auth0.issuer || '',
  },
  async () => (await settings.getSession())?.refreshToken,
  async refreshToken => {
    const session = await settings.getSession();
    if (!session?.refreshToken) return;
    await settings.setSession({ ...session, refreshToken });
  },
);

export const refresh = (): ReturnType<typeof refreshFromAuth0> =>
  isEmbedded()
    ? (refreshFromHost() as unknown as ReturnType<typeof refreshFromAuth0>)
    : refreshFromAuth0();

export const refreshTokenAccessToken = async () => {
  const session = (await settings.getSession()) as Session;
  const response = await refresh();

  const { accessToken, refreshToken, expiresIn } =
    response as unknown as TokenResponse;

  const newTokenPayload: Session = {
    ...session,
    token: accessToken as string,
    refreshToken: refreshToken as string,
    expiredDate: (expiresIn as number) * 1000,
  };
  sessionSubject.next(newTokenPayload);
  await settings.setSession(newTokenPayload);
  return { accessToken };
};
